import { QueryHookOptions, useQuery, gql } from '@apollo/client';

type TLocationItem = {
  id: string;
  slug: string;
  name: string;
};

export type TCity = {
  id: string;
  slug: string;
  name: string;
  nameLocativeCase: string;
  lat: number;
  long: number;
  hasCityDistricts?: boolean;
  region: TLocationItem;
  neighbourhoods?: TLocationItem[];
};

export type TNearbyCity = {
  id: string;
  slug: string;
  name: string;
};

const cityBySlugQuery = gql`
  query cityBySlug($slug: String!) {
    cityBySlug(slug: $slug) {
      id
      slug
      name
      nameLocativeCase
      lat
      long
      hasCityDistricts
      region {
        id
        name
      }
      neighbourhoods {
        id
        name
        slug
      }
    }
  }
`;

export const nearbyCitiesQuery = gql`
  query nearbyCities($slug: String!) {
    nearbyCities(slug: $slug) {
      id
      name
      slug
    }
  }
`;

export const useCityBySlugQuery = (options?: QueryHookOptions) => {
  const result = useQuery<{
    cityBySlug: TCity;
  }>(cityBySlugQuery, options);
  return result;
};

export const useNearbyCitiesQuery = (options?: QueryHookOptions) => {
  const result = useQuery<{
    nearbyCities: TNearbyCity[];
  }>(nearbyCitiesQuery, options);
  return result;
};

export const cityDistrictsQuery = gql`
  query CityDistricts($cityId: ID!) {
    cityDistricts(id: $cityId) {
      id
      name
    }
  }
`;

export type CityDistrict = { id: string; name: string };

export type CityDistrictsResponse = {
  cityDistricts: CityDistrict[];
};

export const useCityDistricts = (cityId: string) => {
  return useQuery<CityDistrictsResponse>(cityDistrictsQuery, {
    variables: {
      cityId: cityId,
    },
  });
};
